/**
 * Check if user has any related role
 * @param {Array|string} userRoles - User's roles (array or single string)
 * @param {Array|string} relatedRoles - Releated roles (array or single string)
 * @returns {boolean} - True if user has any mitra role
 */
export const hasRole = (userRoles, relatedRoles) => {
  if (!userRoles) return false;
  
  const roles = Array.isArray(userRoles) ? userRoles : [userRoles];
  const related = Array.isArray(relatedRoles) ? relatedRoles : [relatedRoles];
  
  return roles.some(role => related.includes(role));
};

// ===========
// Mitra roles
// ===========
export const ROLE_ADMIN_PJO = 'adminpjo';

export const ROLE_HSE = 'hsetraining';

export const ROLE_ADMIN_MITRA = 'adminmitra';

// ===========
// BIB roles
// ===========
export const ROLE_BIB_HR_OPERATIONS_JAKARTA = 'hr-operationsjakarta';

export const ROLE_BIB_HR_OPERATIONS_SITE = 'hr-operationssite';

// ===========
// Employee roles
// ===========
export const ROLE_EMPLOYEE = 'employee';

// All mitra-related roles
export const MITRA_ROLES = [ROLE_ADMIN_PJO, ROLE_HSE, ROLE_ADMIN_MITRA];

export const hasMitraRole = (userRoles) => {
  return hasRole(userRoles, MITRA_ROLES);
};

// All BIB
export const BIB_ROLES = [ROLE_BIB_HR_OPERATIONS_JAKARTA];

// Manager Role
export const ROLE_MANAGER = 'manager';

// HR
export const ROLE_HR = 'hr';